const sizeObject = {
    nb: 'rn',
    s: 'p',
    m: 'm',
    b: 'g',
    oneYear: '1',
    twoYear: '2',
    un: 'un'
  };

export default sizeObject;
